var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var DID_PLACEHOLDER = 'GENESIS';
/**
 * A class for creating ipfs based DID Documents.
 * Based on the DID spec: https://w3c-ccg.github.io/did-spec/
 */

var DidDocument = /*#__PURE__*/function () {
  "use strict";

  /**
   * Create a new DID Document.
   *
   * @param     {Object}        ipfs            An js-ipfs instance
   * @param     {String}        method          The name of the DID Method
   * @return    {DidDocument}                   self
   */
  function DidDocument(ipfs, method) {
    _classCallCheck(this, DidDocument);

    this._ipfs = ipfs;
    this._content = {
      id: "did:".concat(method, ":").concat(DID_PLACEHOLDER)
    };
  }

  _createClass(DidDocument, [{
    key: "DID",
    get: function get() {
      if (this._content.id.includes(DID_PLACEHOLDER)) {
        throw new Error('DID is not available before commit');
      }

      return this._content.id;
    }
    /**
     * Load an already existing DID Document.
     *
     * @param     {Object}        ipfs            An js-ipfs instance
     * @param     {String}        documentCid     The CID of the document
     * @return    {Promise<DidDocument>}                   self
     */

  }, {
    key: "addPublicKey",
    value:
    /**
     * Add a new public key
     *
     * @param     {String}        id              The id of the key, e.g. "key1"
     * @param     {String}        type            The type of the key
     * @param     {String}        encoding        The encoding of the key
     * @param     {String}        key             The encoded public key
     * @param     {String}        owner           The owner of the key (optional)
     */
    function addPublicKey(id, type, encoding, key, owner) {
      if (!this._content.publicKey) {
        this._content.publicKey = [];
      }

      var entry = {
        id: "".concat(this._content.id, "#").concat(id),
        type: type
      };
      entry[encoding] = key;

      if (owner) {
        entry.owner = owner;
      }

      this._content.publicKey.push(entry);
    }
    /**
     * Remove a public key
     *
     * @param     {String}        id              The id of the key, e.g. "key1"
     */

  }, {
    key: "removePublicKey",
    value: function removePublicKey(id) {
      var idx = this._content.publicKey.findIndex(function (e) {
        return e.id.endsWith(id);
      });

      this._content.publicKey.splice(idx, 1);

      if (!this._content.publicKey.length) {
        delete this._content.publicKey;
      }
    }
    /**
     * Add a new authentication
     *
     * @param     {String}        type            The type of the authentication
     * @param     {String}        id              The id of the key to be used, e.g. "key1"
     */

  }, {
    key: "addAuthentication",
    value: function addAuthentication(type, id) {
      if (!this._content.authentication) {
        this._content.authentication = [];
      }

      this._content.authentication.push({
        type: type,
        publicKey: "".concat(this._content.id, "#").concat(id)
      });
    }
    /**
     * Remove an authentication
     *
     * @param     {String}        id              The id of the key, e.g. "key1"
     */

  }, {
    key: "removeAuthentication",
    value: function removeAuthentication(id) {
      var idx = this._content.authentication.findIndex(function (e) {
        return e.publicKey.endsWith(id);
      });

      this._content.authentication.splice(idx, 1);

      if (!this._content.authentication.length) {
        delete this._content.authentication;
      }
    }
    /**
     * Add a new service
     *
     * @param     {String}        id                  The id of the key to be used, e.g. "key1"
     * @param     {String}        type                The type of the service
     * @param     {String}        serviceEndpoint     The endpoint of the service
     * @param     {Object}        additionalFields    Any additional fields (optional)
     */

  }, {
    key: "addService",
    value: function addService(id, type, serviceEndpoint, additionalFields) {
      if (!this._content.service) {
        this._content.service = [];
      }

      this._content.service.push(Object.assign({
        id: "".concat(this._content.id, ";").concat(id),
        type: type,
        serviceEndpoint: serviceEndpoint
      }, additionalFields));
    }
    /**
     * Remove a service
     *
     * @param     {String}        id              The id of the key, e.g. "key1"
     */

  }, {
    key: "removeService",
    value: function removeService(id) {
      var idx = this._content.service.findIndex(function (e) {
        return e.id.endsWith(id);
      });

      this._content.service.splice(idx, 1);

      if (!this._content.service.length) {
        delete this._content.service;
      }
    }
    /**
     * Set the revocationMethod. This can be of any js object
     * and is determined by the implementer of a revocation module.
     *
     * @param     {Object}        methodDescriptor    the object that defines the revocation method
     */

  }, {
    key: "setRevocationMethod",
    value: function setRevocationMethod(methodDescriptor) {
      this._content.revocationMethod = methodDescriptor;
    }
    /**
     * Add a new property
     *
     * @param     {String}        propName            The name of the property
     * @param     {Object}        propValue           The value of the property
     */

  }, {
    key: "addCustomProperty",
    value: function addCustomProperty(propName, propValue) {
      this._content[propName] = propValue;
    }
    /**
     * Remove a property
     *
     * @param     {String}        propName            The name of the property
     */

  }, {
    key: "removeCustomProperty",
    value: function removeCustomProperty(propName) {
      delete this._content[propName];
    }
    /**
     * Commit all changes and create a new ipfs dag object.
     *
     * @param     {Object}        opts                Optional parameters
     * @param     {Boolean}       noTimestamp         Don't use timestamps if true
     *
     * @return    {Promise<CID>}                   The CID of the object
     */

  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var opts,
            cid,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};

                if (!this._content.created) {
                  this._content['@context'] = 'https://w3id.org/did/v1';

                  if (!opts.noTimestamp) {
                    this._content.created = new Date(Date.now()).toISOString();
                  }
                } else if (!opts.noTimestamp) {
                  this._content.updated = new Date(Date.now()).toISOString();
                }

                _context.next = 4;
                return this._ipfs.dag.put(this._content, {
                  format: 'dag-cbor',
                  hashAlg: 'sha2-256'
                });

              case 4:
                cid = _context.sent;
                _context.next = 7;
                return DidDocument.cidToDocument(this._ipfs, cid);

              case 7:
                this._content = _context.sent;
                this._content.previousDocument = {
                  '/': cid.toString()
                };
                return _context.abrupt("return", cid);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function commit() {
        return _commit.apply(this, arguments);
      }

      return commit;
    }()
    /**
     * Returns the DID document of a document CID
     *
     * @param     {Object}        ipfs            An js-ipfs instance
     * @param     {String}        documentCid     The CID of the document
     * @return    {Promise<Object>}                        The DID document as a js object
     */

  }], [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ipfs, documentCid) {
        var doc;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                doc = new DidDocument(ipfs);
                _context2.next = 3;
                return DidDocument.cidToDocument(ipfs, documentCid);

              case 3:
                doc._content = _context2.sent;
                doc._content.previousDocument = {
                  '/': documentCid.toString()
                };
                return _context2.abrupt("return", doc);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "cidToDocument",
    value: function () {
      var _cidToDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ipfs, documentCid) {
        var doc, re;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ipfs.dag.get(documentCid);

              case 2:
                doc = _context3.sent.value;

                // If genesis document replace placeholder identifier with cid
                if (doc.id.includes(DID_PLACEHOLDER)) {
                  re = new RegExp(DID_PLACEHOLDER, 'gi');
                  doc.id = doc.id.replace(re, documentCid);

                  if (doc.publicKey) {
                    doc.publicKey = JSON.parse(JSON.stringify(doc.publicKey).replace(re, documentCid));
                  }

                  if (doc.authentication) {
                    doc.authentication = JSON.parse(JSON.stringify(doc.authentication).replace(re, documentCid));
                  }

                  if (doc.service) {
                    doc.service = JSON.parse(JSON.stringify(doc.service).replace(re, documentCid));
                  }
                }

                if (doc.previousDocument) {
                  // make CID human readable
                  doc.previousDocument = {
                    '/': doc.previousDocument.toString()
                  };
                }

                return _context3.abrupt("return", doc);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function cidToDocument(_x3, _x4) {
        return _cidToDocument.apply(this, arguments);
      }

      return cidToDocument;
    }()
  }]);

  return DidDocument;
}();

module.exports = DidDocument;